import React from 'react'
import './sectionAwards.scss'
import BannerJackpot from '../../atoms/bannerJackpot/bannerJackpot'
import SlideAwards from '../../molecules/slideAwards/slideAwards'
import Button from '../../atoms/button/button'
import { navigate } from 'gatsby'
import { initialDate, LOCALE } from '../../../constants/activity-constants'
import SingleAward from '../../molecules/singleAward/singleAward'
import { datesFase2 } from '../../../constants/activity-constants'

const SectionAwards = ({ section = '' }) => {
  return (
    <section className="f-awards">
      <div className="f-awards__wrapper">
        <h2 className="f-awards__title">¿Qué podrás ganar?</h2>
        <p className="f-awards__description">
          {LOCALE === 'es-CL' ? (
            <>
              Este año tendrás la oportunidad de hacer los retos que quieras,
              las veces que quieras desde el{' '}
              <b className="f-pink">1 hasta el 23 de febrero 2023. </b>
              Para ganar tendremos en cuenta tu misión como Embajadora y tu
              participación en los retos, queremos que{' '}
              <b>
                publiques en tus redes sociales todo lo relacionado con tu labor
                mientras compartes con amigas y conocidas sobre la nueva
                Tecnología Cur-V.
              </b>
            </>
          ) : (
            <>
              Este año tendrás la oportunidad de hacer los retos que quieras,
              las veces que quieras desde el {datesFase2.startDateFase2} hasta
              el {datesFase2.finishDateFase2}. Para ganar tendremos en cuenta tu
              misión como Embajadora y tu participación en los tres retos,
              queremos que publiques en tus redes sociales todo lo relacionado
              con tu labor mientras compartes con amigas y conocidas sobre la
              nueva Tecnología Cur-V.
            </>
          )}
        </p>
        <BannerJackpot />
        <SlideAwards section={section} />
        {section !== 'awards' && (
          <div className="f-awards__button">
            <Button
              title={'ir a premios'}
              color="blue"
              onClick={() => navigate('/premios')}
            />
          </div>
        )}
        <p className="f-awards__legal">
          {LOCALE === 'es-CL'
            ? '*Las imágenes utilizadas son de referencia.'
            : '*Las imágenes utilizadas son de referencia. Los productos del kit de maquillaje pueden variar.'}
        </p>
        {/*<SingleAward />*/}
      </div>
    </section>
  )
}

export default SectionAwards
